import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import VerticalSpan from "../../assets/icons/animated-horizontal-lines.gif";
import DownwardArrows from "../../assets/icons/downward-arrows.png";
import Session10 from "../../assets/images/sesion-10.png";
import Session13 from "../../assets/images/sesion-13.png";
import Session20 from "../../assets/images/sesion-20.png";
import Session52 from "../../assets/images/sesion-52.png";
import BzrpMainImg from "../../assets/images/biza-main-img.gif";
import StaticCover from "../../assets/images/static-cover.gif";

const sxStyles = {
  mainContainer: {
    backgroundColor: "black",
    alignItems: "center",
    display: "flex",
    backgroundSize: "cover",
    justifyContent: "center",
    flexGrow: 1,
    overflow: "hidden",
    position: "relative",
    height: { xs: "1000px", md: "900px" },
    width: { xs: "375px", md: "100%" },
    paddingTop: { xs: "40px", md: "100px", xl: 0 },
    flexDirection: { xs: "column", md: "row" },
  },
  staticCover: {
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
    overflow: "hidden",
  },
  content: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "flex-start",
    justifyContent: "flex-end",
    width: { xs: "375px", md: "1440px" },
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
    paddingTop: { xs: "70px", md: "190px" },
  },
  sectionText: {
    color: "white",
    fontSize: { xs: "16px", md: "24px" },
    fontFamily: "IBM Plex Sans",
    fontWeight: "400",
    lineHeight: { xs: "24px", md: "34px" },
    textAlign: "left",
    maxWidth: { xs: "355px", md: "100%" },
    paddingLeft: { xs: "20px", md: 0 },
  },
  p2Title: {
    color: "white",
    fontFamily: "p22-arts-and-crafts",
    fontSize: { xs: "36px", md: "45px", xl: "65px" },
    fontWeight: "700",
    lineHeight: { xs: "37px", md: "48px", xl: "68px" },
    position: "relative",
    top: { md: "-50px", xl: "-68px" },
    left: { md: "70px", xl: "160px" },
  },
  title: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "36px", md: "45px", xl: "65px" },
    fontWeight: "400",
    lineHeight: { xs: "37px", md: "48px", xl: "68px" },
  },
  secondTitle: {
    color: "#FDD925",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "35px", md: "64px" },
    fontWeight: "700",
    lineHeight: { xs: "35px", md: "65px" },
    marginRight: "13px",
    marginBottom: "32px",
  },
};

const ContestSessions = () => {
  return (
    <Grid sx={sxStyles.mainContainer}>
      <Box
        sx={{
          height: { xs: "750px", md: "600px", xl: "900px" },
          width: { xs: "375px", md: "1440px", xl: "1920px" },
          position: "absolute",
          backgroundImage: `url(${StaticCover})`,
          opacity: "25%",
          zIndex: "1",
        }}
      />
      <Stack>
        <img
          src={VerticalSpan}
          alt={""}
          style={{
            position: "relative",
            width: "30px",
            height: "15px",
            top: "-330px",
          }}
        />
        <img
          src={VerticalSpan}
          alt={""}
          style={{
            position: "relative",
            width: "30px",
            height: "15px",
            top: "-300px",
          }}
        />
        <img
          src={VerticalSpan}
          alt={""}
          style={{
            position: "relative",
            width: "30px",
            height: "15px",
            top: "-270px",
          }}
        />
      </Stack>
      <Stack
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: { md: "center", xl: "flex-start" },
          marginBottom: { xs: "80px", md: "150px" },
          width: { xs: "80%", md: "40%" },
          marginRight: { xs: 0, md: "50px" },
          paddingRight: { md: 0, xl: "200px" },
        }}
      >
        <Typography
          sx={{
            color: "white",
            fontFamily: "IBM Plex Sans",
            fontSize: { xs: "36px", md: "45px" },
            fontWeight: "400",
            lineHeight: { xs: "37px", md: "65px" },
            alignSelf: "center",
            marginBottom: "30px",
          }}
        >
          2.{" "}
        </Typography>
        <Box sx={{ display: { xs: "none", md: "flex" } }}>
          <Typography sx={sxStyles.title}>COMPLETÁ CUALQUIERA</Typography>
        </Box>
        <Stack
          sx={{
            display: {
              xs: "flex",
              md: "none",
              width: "320px",
            },
          }}
        >
          <Typography sx={sxStyles.title}>COMPLETÁ </Typography>
          <Typography
            sx={{
              color: "white",
              fontFamily: "IBM Plex Sans",
              fontSize: { xs: "36px", md: "45px", xl: "65px" },
              fontWeight: "400",
              lineHeight: { xs: "37px", md: "48px", xl: "68px" },
            }}
          >
            CUALQUIERA
          </Typography>
        </Stack>
        <Grid>
          <Typography
            sx={{
              color: "white",
              fontFamily: "IBM Plex Sans",
              fontSize: { xs: "36px", md: "45px", xl: "65px" },
              fontWeight: "400",
              lineHeight: { xs: "37px", md: "48px", xl: "68px" },
              paddingRight: { xs: 0, md: "315px", xl: "340px" },
            }}
          >
            DE ESTAS
          </Typography>
          <Typography sx={sxStyles.p2Title}>SESSIONS</Typography>
        </Grid>
      </Stack>
      <Stack
        sx={{
          display: "flex",
          zIndex: 2,
          paddingTop: { xs: 0, md: 0, xl: "100px" },
        }}
      >
        <Grid sx={{ display: "flex", flexDirection: "row" }}>
          <Box
            sx={{
              width: { xs: "150px", md: "250px" },
              height: { xs: "210px", md: "340px" },
              paddingTop: { xs: 0, md: "50px" },
              backgroundImage: `url(${Session10})`,
              backgroundSize: "contain",
              top: { xs: "460px", md: "-50px" },
              left: { xs: "45px", md: "unset" },
              right: { xs: 0, md: "unset" },
              marginRight: "15px",
              backgroundRepeat: "no-repeat",
            }}
          />
          <Box
            sx={{
              width: { xs: "150px", md: "250px" },
              height: { xs: "210px", md: "340px" },
              paddingTop: { xs: 0, md: "50px" },
              backgroundImage: `url(${Session13})`,
              backgroundSize: "contain",
              top: { xs: "460px", md: "-50px" },
              left: { xs: "45px", md: "unset" },
              right: { xs: 0, md: "unset" },
              backgroundRepeat: "no-repeat",
            }}
          />
        </Grid>
        <Grid sx={{ display: "flex", flexDirection: "row" }}>
          <Box
            sx={{
              width: { xs: "150px", md: "250px" },
              height: { xs: "210px", md: "340px" },
              paddingTop: { xs: 0, md: "50px" },
              backgroundImage: `url(${Session20})`,
              backgroundSize: "contain",
              top: { xs: "460px", md: "-50px" },
              left: { xs: "45px", md: "unset" },
              right: { xs: 0, md: "unset" },
              marginRight: "15px",
              backgroundRepeat: "no-repeat",
            }}
          />
          <Box
            sx={{
              width: { xs: "150px", md: "250px" },
              height: { xs: "210px", md: "340px" },
              paddingTop: { xs: 0, md: "50px" },
              backgroundImage: `url(${Session52})`,
              backgroundSize: "contain",
              top: { xs: "460px", md: "-50px" },
              left: { xs: "45px", md: "unset" },
              right: { xs: 0, md: "unset" },
              backgroundRepeat: "no-repeat",
            }}
          />
        </Grid>
        <Box
          sx={{
            position: "relative",
            left: { xs: "150px", md: "-680px" },
            bottom: { xs: "-30px", md: "150px" },
            width: "15px",
            height: "60px",
            backgroundImage: `url(${DownwardArrows})`,
          }}
        />
        <Stack>
          <Box
            sx={{
              position: "relative",
              left: { xs: "300px", md: "-70px" },
              bottom: { xs: "20px", md: "150px" },
              width: "30px",
              height: "70px",
              backgroundImage: `url(${VerticalSpan})`,
              backgroundSize: "contain",
            }}
          />
        </Stack>
      </Stack>
    </Grid>
  );
};

export default ContestSessions;
